// Only fire the supplied callback if the event
// was triggered by the specified key
var keyPressed = function (key, func) { return function (event) {
    if (event.key === key) {
        func(event);
    }
}; };
export default keyPressed;
//# sourceMappingURL=a11y.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@sm/smapply-ui/dist/es/utils/a11y.js
// module id = 1790
// module chunks = 17